<a class="nav-tile" [routerLink]="path">
  <span class="nav-tile__icon" aria-hidden="true">{{ icon }}</span>
  <span class="nav-tile__label">{{ label }}</span>
  @if (subtitle) {
    <span class="nav-tile__subtitle">{{ subtitle }}</span>
  }
</a>
